export default {"src":"/_next/static/media/twitter.2683e9b5.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};